var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSrtruckingSmallLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 292.685,
    height: 312.957,
    viewBox: "0 0 292.685 312.957",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(339.765 7680.357)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    x1: 34,
    y2: 296,
    transform: "matrix(1, -0.017, 0.017, 1, -319.858, -7665.984)",
    fill: "none",
    stroke: "#b7ff64",
    strokeWidth: 40
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x1: 32,
    y2: 296,
    transform: "matrix(1, -0.017, 0.017, 1, -211.007, -7671.653)",
    fill: "none",
    stroke: "#f83f2f",
    strokeWidth: 40
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    x1: 33,
    y2: 296,
    transform: "matrix(1, -0.017, 0.017, 1, -105.152, -7677.218)",
    fill: "none",
    stroke: "#b7ff64",
    strokeWidth: 40
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSrtruckingSmallLogo);
export default __webpack_public_path__ + "static/media/srtrucking_small_logo.646e8866dc7fe867f209d9e997e56417.svg";
export { ForwardRef as ReactComponent };